(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[499],{

/***/ 70222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "cV": function() { return /* binding */ CONTEXT_VERSION; },
/* harmony export */   "UO": function() { return /* binding */ LeafletProvider; },
/* harmony export */   "mE": function() { return /* binding */ useLeafletContext; }
/* harmony export */ });
/* unused harmony export LeafletContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

var CONTEXT_VERSION = 1;
var LeafletContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
var LeafletProvider = LeafletContext.Provider;
function useLeafletContext() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(LeafletContext);
    if (context == null) {
        throw new Error('No context provided: useLeafletContext() can only be used in a descendant of <MapContainer>');
    }
    return context;
}


/***/ }),

/***/ 78794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "vm": function() { return /* binding */ createControlComponent; },
  "dW": function() { return /* binding */ createLayerComponent; },
  "SO": function() { return /* binding */ createOverlayComponent; },
  "Au": function() { return /* binding */ createPathComponent; },
  "Lf": function() { return /* binding */ createTileLayerComponent; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(28316);
// EXTERNAL MODULE: ../../node_modules/@react-leaflet/core/esm/context.js
var esm_context = __webpack_require__(70222);
;// CONCATENATED MODULE: ../../node_modules/@react-leaflet/core/esm/component.js



function createContainerComponent(useElement) {
    var ContainerComponent = function ContainerComponent(props, ref) {
        var _current = useElement(props).current, instance = _current.instance, context = _current.context;
        (0,react.useImperativeHandle)(ref, function() {
            return instance;
        });
        return props.children == null ? null : /*#__PURE__*/ react.createElement(esm_context/* LeafletProvider */.UO, {
            value: context
        }, props.children);
    };
    return(/*#__PURE__*/ (0,react.forwardRef)(ContainerComponent));
}
function createDivOverlayComponent(useElement) {
    var OverlayComponent = function OverlayComponent(props, ref) {
        var ref1 = (0,react.useState)(false), isOpen = ref1[0], setOpen = ref1[1];
        var instance = useElement(props, setOpen).current.instance;
        (0,react.useImperativeHandle)(ref, function() {
            return instance;
        });
        (0,react.useEffect)(function updateOverlay() {
            if (isOpen) {
                instance.update();
            }
        }, [
            instance,
            isOpen,
            props.children
        ]); // @ts-ignore _contentNode missing in type definition
        var contentNode = instance._contentNode;
        return contentNode ? /*#__PURE__*/ (0,react_dom.createPortal)(props.children, contentNode) : null;
    };
    return(/*#__PURE__*/ (0,react.forwardRef)(OverlayComponent));
}
function createLeafComponent(useElement) {
    var LeafComponent = function LeafComponent(props, ref) {
        var instance = useElement(props).current.instance;
        (0,react.useImperativeHandle)(ref, function() {
            return instance;
        });
        return null;
    };
    return(/*#__PURE__*/ (0,react.forwardRef)(LeafComponent));
}

;// CONCATENATED MODULE: ../../node_modules/@react-leaflet/core/esm/control.js


function createControlHook(useElement) {
    return function useLeafletControl(props) {
        var context = (0,esm_context/* useLeafletContext */.mE)();
        var elementRef = useElement(props, context);
        var instance = elementRef.current.instance;
        var positionRef = (0,react.useRef)(props.position);
        var position = props.position;
        (0,react.useEffect)(function addControl() {
            instance.addTo(context.map);
            return function removeControl() {
                instance.remove();
            };
        }, [
            context.map,
            instance
        ]);
        (0,react.useEffect)(function updateControl() {
            if (position != null && position !== positionRef.current) {
                instance.setPosition(position);
                positionRef.current = position;
            }
        }, [
            instance,
            position
        ]);
        return elementRef;
    };
}

;// CONCATENATED MODULE: ../../node_modules/@react-leaflet/core/esm/element.js

function createElementHook(createElement, updateElement) {
    if (updateElement == null) {
        return function useImmutableLeafletElement(props, context) {
            return (0,react.useRef)(createElement(props, context));
        };
    }
    return function useMutableLeafletElement(props, context) {
        var elementRef = (0,react.useRef)(createElement(props, context));
        var propsRef = (0,react.useRef)(props);
        var instance = elementRef.current.instance;
        (0,react.useEffect)(function updateElementProps() {
            if (propsRef.current !== props) {
                updateElement(instance, props, propsRef.current);
                propsRef.current = props;
            }
        }, [
            instance,
            props,
            context
        ]);
        return elementRef;
    };
}

;// CONCATENATED MODULE: ../../node_modules/@react-leaflet/core/esm/attribution.js

function useAttribution(map, attribution) {
    var attributionRef = (0,react.useRef)(attribution);
    (0,react.useEffect)(function updateAttribution() {
        if (attribution !== attributionRef.current && map.attributionControl != null) {
            if (attributionRef.current != null) {
                map.attributionControl.removeAttribution(attributionRef.current);
            }
            if (attribution != null) {
                map.attributionControl.addAttribution(attribution);
            }
        }
        attributionRef.current = attribution;
    }, [
        map,
        attribution
    ]);
}

;// CONCATENATED MODULE: ../../node_modules/@react-leaflet/core/esm/events.js

function useEventHandlers(element, eventHandlers) {
    var eventHandlersRef = (0,react.useRef)();
    (0,react.useEffect)(function addEventHandlers() {
        if (eventHandlers != null) {
            element.instance.on(eventHandlers);
        }
        eventHandlersRef.current = eventHandlers;
        return function removeEventHandlers() {
            if (eventHandlersRef.current != null) {
                element.instance.off(eventHandlersRef.current);
            }
            eventHandlersRef.current = null;
        };
    }, [
        element,
        eventHandlers
    ]);
}

// EXTERNAL MODULE: ../../node_modules/@react-leaflet/core/esm/pane.js
var pane = __webpack_require__(57961);
;// CONCATENATED MODULE: ../../node_modules/@react-leaflet/core/esm/layer.js





function useLayerLifecycle(element, context) {
    (0,react.useEffect)(function addLayer() {
        var _layerContainer;
        var container = (_layerContainer = context.layerContainer) !== null && _layerContainer !== void 0 ? _layerContainer : context.map;
        container.addLayer(element.instance);
        return function removeLayer() {
            var _context$layerContain;
            (_context$layerContain = context.layerContainer) == null ? void 0 : _context$layerContain.removeLayer(element.instance);
            context.map.removeLayer(element.instance);
        };
    }, [
        context,
        element
    ]);
}
function createLayerHook(useElement) {
    return function useLayer(props) {
        var context = (0,esm_context/* useLeafletContext */.mE)();
        var elementRef = useElement((0,pane/* withPane */.q)(props, context), context);
        useAttribution(context.map, props.attribution);
        useEventHandlers(elementRef.current, props.eventHandlers);
        useLayerLifecycle(elementRef.current, context);
        return elementRef;
    };
}

;// CONCATENATED MODULE: ../../node_modules/@react-leaflet/core/esm/div-overlay.js




function createDivOverlayHook(useElement, useLifecycle) {
    return function useDivOverlay(props, setOpen) {
        var context = (0,esm_context/* useLeafletContext */.mE)();
        var elementRef = useElement((0,pane/* withPane */.q)(props, context), context);
        useAttribution(context.map, props.attribution);
        useEventHandlers(elementRef.current, props.eventHandlers);
        useLifecycle(elementRef.current, context, props, setOpen);
        return elementRef;
    };
}

;// CONCATENATED MODULE: ../../node_modules/@react-leaflet/core/esm/path.js





function usePathOptions(element, props) {
    var optionsRef = (0,react.useRef)();
    (0,react.useEffect)(function updatePathOptions() {
        if (props.pathOptions !== optionsRef.current) {
            var _pathOptions;
            var options = (_pathOptions = props.pathOptions) !== null && _pathOptions !== void 0 ? _pathOptions : {};
            element.instance.setStyle(options);
            optionsRef.current = options;
        }
    }, [
        element,
        props
    ]);
}
function createPathHook(useElement) {
    return function usePath(props) {
        var context = (0,esm_context/* useLeafletContext */.mE)();
        var elementRef = useElement((0,pane/* withPane */.q)(props, context), context);
        useEventHandlers(elementRef.current, props.eventHandlers);
        useLayerLifecycle(elementRef.current, context);
        usePathOptions(elementRef.current, props);
        return elementRef;
    };
}

;// CONCATENATED MODULE: ../../node_modules/@react-leaflet/core/esm/generic.js






function createControlComponent(createInstance) {
    var createElement = function createElement(props, context) {
        return {
            instance: createInstance(props),
            context: context
        };
    };
    var useElement = createElementHook(createElement);
    var useControl = createControlHook(useElement);
    return createLeafComponent(useControl);
}
function createLayerComponent(createElement, updateElement) {
    var useElement = createElementHook(createElement, updateElement);
    var useLayer = createLayerHook(useElement);
    return createContainerComponent(useLayer);
}
function createOverlayComponent(createElement, useLifecycle) {
    var useElement = createElementHook(createElement);
    var useOverlay = createDivOverlayHook(useElement, useLifecycle);
    return createDivOverlayComponent(useOverlay);
}
function createPathComponent(createElement, updateElement) {
    var useElement = createElementHook(createElement, updateElement);
    var usePath = createPathHook(useElement);
    return createContainerComponent(usePath);
}
function createTileLayerComponent(createElement, updateElement) {
    var useElement = createElementHook(createElement, updateElement);
    var useLayer = createLayerHook(useElement);
    return createLeafComponent(useLayer);
}


/***/ }),

/***/ 57961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ withPane; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function withPane(props, context) {
    var _pane;
    var pane = (_pane = props.pane) !== null && _pane !== void 0 ? _pane : context.pane;
    return pane ? _objectSpread({}, props, {
        pane: pane
    }) : props;
}


/***/ }),

/***/ 39443:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_LOCAL_MODULE_0__, __WEBPACK_LOCAL_MODULE_0__factory, __WEBPACK_LOCAL_MODULE_0__module;var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
/*!
* Based on package 'screenfull'
* v5.1.0 - 2020-12-24
* (c) Sindre Sorhus; MIT License
* Added definition for using screenfull as an amd module
* Must be placed before the definition of leaflet.fullscreen
* as it is required by that
*/ (function(root, factory) {
    if (true) {
        !(__WEBPACK_LOCAL_MODULE_0__factory = (factory), (typeof __WEBPACK_LOCAL_MODULE_0__factory === 'function' ? ((__WEBPACK_LOCAL_MODULE_0__module = { id: "screenfull", exports: {}, loaded: false }), (__WEBPACK_LOCAL_MODULE_0__ = __WEBPACK_LOCAL_MODULE_0__factory.call(__WEBPACK_LOCAL_MODULE_0__module.exports, __webpack_require__, __WEBPACK_LOCAL_MODULE_0__module.exports, __WEBPACK_LOCAL_MODULE_0__module)), (__WEBPACK_LOCAL_MODULE_0__module.loaded = true), __WEBPACK_LOCAL_MODULE_0__ === undefined && (__WEBPACK_LOCAL_MODULE_0__ = __WEBPACK_LOCAL_MODULE_0__module.exports)) : __WEBPACK_LOCAL_MODULE_0__ = __WEBPACK_LOCAL_MODULE_0__factory));
    } else {}
})(void 0, function() {
    'use strict';
    var document =  true && typeof window.document !== 'undefined' ? window.document : {};
    var fn = function() {
        var val;
        var fnMap = [
            [
                'requestFullscreen',
                'exitFullscreen',
                'fullscreenElement',
                'fullscreenEnabled',
                'fullscreenchange',
                'fullscreenerror'
            ],
            // New WebKit
            [
                'webkitRequestFullscreen',
                'webkitExitFullscreen',
                'webkitFullscreenElement',
                'webkitFullscreenEnabled',
                'webkitfullscreenchange',
                'webkitfullscreenerror'
            ],
            // Old WebKit
            [
                'webkitRequestFullScreen',
                'webkitCancelFullScreen',
                'webkitCurrentFullScreenElement',
                'webkitCancelFullScreen',
                'webkitfullscreenchange',
                'webkitfullscreenerror'
            ],
            [
                'mozRequestFullScreen',
                'mozCancelFullScreen',
                'mozFullScreenElement',
                'mozFullScreenEnabled',
                'mozfullscreenchange',
                'mozfullscreenerror'
            ],
            [
                'msRequestFullscreen',
                'msExitFullscreen',
                'msFullscreenElement',
                'msFullscreenEnabled',
                'MSFullscreenChange',
                'MSFullscreenError'
            ]
        ];
        var i = 0;
        var l = fnMap.length;
        var ret = {};
        for(; i < l; i++){
            val = fnMap[i];
            if (val && val[1] in document) {
                for(i = 0; i < val.length; i++){
                    ret[fnMap[0][i]] = val[i];
                }
                return ret;
            }
        }
        return false;
    }();
    var eventNameMap = {
        change: fn.fullscreenchange,
        error: fn.fullscreenerror
    };
    var screenfull = {
        request: function request(element, options) {
            return new Promise((function(resolve, reject) {
                var onFullScreenEntered = (function() {
                    this.off('change', onFullScreenEntered);
                    resolve();
                }).bind(this);
                this.on('change', onFullScreenEntered);
                element = element || document.documentElement;
                var returnPromise = element[fn.requestFullscreen](options);
                if (_instanceof(returnPromise, Promise)) {
                    returnPromise.then(onFullScreenEntered).catch(reject);
                }
            }).bind(this));
        },
        exit: function exit() {
            return new Promise((function(resolve, reject) {
                if (!this.isFullscreen) {
                    resolve();
                    return;
                }
                var onFullScreenExit = (function() {
                    this.off('change', onFullScreenExit);
                    resolve();
                }).bind(this);
                this.on('change', onFullScreenExit);
                var returnPromise = document[fn.exitFullscreen]();
                if (_instanceof(returnPromise, Promise)) {
                    returnPromise.then(onFullScreenExit).catch(reject);
                }
            }).bind(this));
        },
        toggle: function toggle(element, options) {
            return this.isFullscreen ? this.exit() : this.request(element, options);
        },
        onchange: function onchange(callback) {
            this.on('change', callback);
        },
        onerror: function onerror(callback) {
            this.on('error', callback);
        },
        on: function on(event, callback) {
            var eventName = eventNameMap[event];
            if (eventName) {
                document.addEventListener(eventName, callback, false);
            }
        },
        off: function off(event, callback) {
            var eventName = eventNameMap[event];
            if (eventName) {
                document.removeEventListener(eventName, callback, false);
            }
        },
        raw: fn
    };
    if (!fn) {
        return {
            isEnabled: false
        };
    } else {
        Object.defineProperties(screenfull, {
            isFullscreen: {
                get: function get() {
                    return Boolean(document[fn.fullscreenElement]);
                }
            },
            element: {
                enumerable: true,
                get: function get() {
                    return document[fn.fullscreenElement];
                }
            },
            isEnabled: {
                enumerable: true,
                get: function get() {
                    // Coerce to boolean in case of old WebKit
                    return Boolean(document[fn.fullscreenEnabled]);
                }
            }
        });
        return screenfull;
    }
});
/*!
* leaflet.fullscreen
*/ (function(root, factory) {
    if (true) {
        // define an AMD module that requires 'leaflet' and 'screenfull'
        // and resolve to an object containing leaflet and screenfull
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
            __webpack_require__(15623),
            __WEBPACK_LOCAL_MODULE_0__
        ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {}
})(void 0, function(leaflet, screenfull) {
    'use strict';
    leaflet.Control.FullScreen = leaflet.Control.extend({
        options: {
            position: 'topleft',
            title: 'Full Screen',
            titleCancel: 'Exit Full Screen',
            forceSeparateButton: false,
            forcePseudoFullscreen: false,
            fullscreenElement: false
        },
        _screenfull: screenfull,
        onAdd: function onAdd(map) {
            var className = 'leaflet-control-zoom-fullscreen', container, content = '';
            if (map.zoomControl && !this.options.forceSeparateButton) {
                container = map.zoomControl._container;
            } else {
                container = leaflet.DomUtil.create('div', 'leaflet-bar');
            }
            if (this.options.content) {
                content = this.options.content;
            } else {
                className += ' fullscreen-icon';
            }
            this._createButton(this.options.title, className, content, container, this.toggleFullScreen, this);
            this._map.fullscreenControl = this;
            this._map.on('enterFullscreen exitFullscreen', this._toggleState, this);
            return container;
        },
        onRemove: function onRemove() {
            leaflet.DomEvent.off(this.link, 'click', leaflet.DomEvent.stopPropagation).off(this.link, 'click', leaflet.DomEvent.preventDefault).off(this.link, 'click', this.toggleFullScreen, this);
            if (this._screenfull.raw) {
                leaflet.DomEvent.off(this._container, this._screenfull.raw.fullscreenchange, leaflet.DomEvent.stopPropagation).off(this._container, this._screenfull.raw.fullscreenchange, leaflet.DomEvent.preventDefault).off(this._container, this._screenfull.raw.fullscreenchange, this._handleFullscreenChange, this);
                leaflet.DomEvent.off(document, this._screenfull.raw.fullscreenchange, leaflet.DomEvent.stopPropagation).off(document, this._screenfull.raw.fullscreenchange, leaflet.DomEvent.preventDefault).off(document, this._screenfull.raw.fullscreenchange, this._handleFullscreenChange, this);
            }
        },
        _createButton: function _createButton(title, className, content, container, fn, context) {
            this.link = leaflet.DomUtil.create('a', className, container);
            this.link.href = '#';
            this.link.title = title;
            this.link.innerHTML = content;
            this.link.setAttribute('role', 'button');
            this.link.setAttribute('aria-label', title);
            leaflet.DomEvent.on(this.link, 'click', leaflet.DomEvent.stopPropagation).on(this.link, 'click', leaflet.DomEvent.preventDefault).on(this.link, 'click', fn, context);
            if (this._screenfull.raw) {
                leaflet.DomEvent.on(container, this._screenfull.raw.fullscreenchange, leaflet.DomEvent.stopPropagation).on(container, this._screenfull.raw.fullscreenchange, leaflet.DomEvent.preventDefault).on(container, this._screenfull.raw.fullscreenchange, this._handleFullscreenChange, context);
                leaflet.DomEvent.on(document, this._screenfull.raw.fullscreenchange, leaflet.DomEvent.stopPropagation).on(document, this._screenfull.raw.fullscreenchange, leaflet.DomEvent.preventDefault).on(document, this._screenfull.raw.fullscreenchange, this._handleFullscreenChange, context);
            }
            return this.link;
        },
        toggleFullScreen: function toggleFullScreen() {
            var map = this._map;
            map._exitFired = false;
            if (map._isFullscreen) {
                if (this._screenfull.isEnabled && !this.options.forcePseudoFullscreen) {
                    this._screenfull.exit();
                } else {
                    leaflet.DomUtil.removeClass(this.options.fullscreenElement ? this.options.fullscreenElement : map._container, 'leaflet-pseudo-fullscreen');
                    map.invalidateSize();
                }
                map.fire('exitFullscreen');
                map._exitFired = true;
                map._isFullscreen = false;
            } else {
                if (this._screenfull.isEnabled && !this.options.forcePseudoFullscreen) {
                    this._screenfull.request(this.options.fullscreenElement ? this.options.fullscreenElement : map._container);
                } else {
                    leaflet.DomUtil.addClass(this.options.fullscreenElement ? this.options.fullscreenElement : map._container, 'leaflet-pseudo-fullscreen');
                    map.invalidateSize();
                }
                map.fire('enterFullscreen');
                map._isFullscreen = true;
            }
        },
        _toggleState: function _toggleState() {
            this.link.title = this._map._isFullscreen ? this.options.title : this.options.titleCancel;
            this._map._isFullscreen ? L.DomUtil.removeClass(this.link, 'leaflet-fullscreen-on') : L.DomUtil.addClass(this.link, 'leaflet-fullscreen-on');
        },
        _handleFullscreenChange: function _handleFullscreenChange() {
            var map = this._map;
            map.invalidateSize();
            if (!this._screenfull.isFullscreen && !map._exitFired) {
                map.fire('exitFullscreen');
                map._exitFired = true;
                map._isFullscreen = false;
            }
        }
    });
    leaflet.Map.include({
        toggleFullscreen: function toggleFullscreen() {
            this.fullscreenControl.toggleFullScreen();
        }
    });
    leaflet.Map.addInitHook(function() {
        if (this.options.fullscreenControl) {
            this.addControl(leaflet.control.fullscreen(this.options.fullscreenControlOptions));
        }
    });
    leaflet.control.fullscreen = function(options) {
        return new leaflet.Control.FullScreen(options);
    };
    // must return an object containing also screenfull to make screenfull
    // available outside of this package, if used as an amd module,
    // as webpack cannot handle amd define with moduleid
    return {
        leaflet: leaflet,
        screenfull: screenfull
    };
});


/***/ }),

/***/ 56628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ MapContainer; }
/* harmony export */ });
/* unused harmony export useMapElement */
/* harmony import */ var _react_leaflet_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70222);
/* harmony import */ var leaflet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15623);
/* harmony import */ var leaflet__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(leaflet__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);



function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function useMapElement(mapRef, props) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), map = ref[0], setMap = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (mapRef.current !== null && map === null) {
            var instance = new leaflet__WEBPACK_IMPORTED_MODULE_0__.Map(mapRef.current, props);
            if (props.center != null && props.zoom != null) {
                instance.setView(props.center, props.zoom);
            } else if (props.bounds != null) {
                instance.fitBounds(props.bounds, props.boundsOptions);
            }
            if (props.whenReady != null) {
                instance.whenReady(props.whenReady);
            }
            setMap(instance);
        }
    }, [
        mapRef,
        map,
        props
    ]);
    return map;
}
function MapContainer(_ref) {
    var children = _ref.children, className = _ref.className, id = _ref.id, placeholder = _ref.placeholder, style = _ref.style, whenCreated = _ref.whenCreated, options = _objectWithoutProperties(_ref, [
        "children",
        "className",
        "id",
        "placeholder",
        "style",
        "whenCreated"
    ]);
    var mapRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var map = useMapElement(mapRef, options);
    var createdRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (map != null && createdRef.current === false && whenCreated != null) {
            createdRef.current = true;
            whenCreated(map);
        }
    }, [
        map,
        whenCreated
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        return function() {
            map == null ? void 0 : map.remove();
        };
    }, [
        map
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        className: className,
        id: id,
        style: style
    }), props = ref[0];
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return map ? {
            __version: _react_leaflet_core__WEBPACK_IMPORTED_MODULE_2__/* .CONTEXT_VERSION */ .cV,
            map: map
        } : null;
    }, [
        map
    ]);
    var contents = context ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(_react_leaflet_core__WEBPACK_IMPORTED_MODULE_2__/* .LeafletProvider */ .UO, {
        value: context
    }, children) : placeholder !== null && placeholder !== void 0 ? placeholder : null;
    return(/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", _extends({}, props, {
        ref: mapRef
    }), contents));
}


/***/ }),

/***/ 1172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I": function() { return /* binding */ TileLayer; }
});

;// CONCATENATED MODULE: ../../node_modules/@react-leaflet/core/esm/grid-layer.js
function updateGridLayer(layer, props, prevProps) {
    var opacity = props.opacity, zIndex = props.zIndex;
    if (opacity != null && opacity !== prevProps.opacity) {
        layer.setOpacity(opacity);
    }
    if (zIndex != null && zIndex !== prevProps.zIndex) {
        layer.setZIndex(zIndex);
    }
}

// EXTERNAL MODULE: ../../node_modules/@react-leaflet/core/esm/generic.js + 8 modules
var generic = __webpack_require__(78794);
// EXTERNAL MODULE: ../../node_modules/@react-leaflet/core/esm/pane.js
var pane = __webpack_require__(57961);
// EXTERNAL MODULE: ../../node_modules/leaflet/dist/leaflet-src.js
var leaflet_src = __webpack_require__(15623);
;// CONCATENATED MODULE: ../../node_modules/react-leaflet/esm/TileLayer.js


function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var TileLayer = (0,generic/* createTileLayerComponent */.Lf)(function createTileLayer(_ref, context) {
    var url = _ref.url, options = _objectWithoutProperties(_ref, [
        "url"
    ]);
    return {
        instance: new leaflet_src.TileLayer(url, (0,pane/* withPane */.q)(options, context)),
        context: context
    };
}, updateGridLayer);



/***/ }),

/***/ 89507:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sx": function() { return /* binding */ useMap; }
/* harmony export */ });
/* unused harmony exports useMapEvent, useMapEvents */
/* harmony import */ var _react_leaflet_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70222);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


function useMap() {
    return (0,_react_leaflet_core__WEBPACK_IMPORTED_MODULE_1__/* .useLeafletContext */ .mE)().map;
}
function useMapEvent(type, handler) {
    var map = useMap();
    useEffect(function addMapEventHandler() {
        // @ts-ignore event type
        map.on(type, handler);
        return function removeMapEventHandler() {
            // @ts-ignore event type
            map.off(type, handler);
        };
    }, [
        map,
        type,
        handler
    ]);
    return map;
}
function useMapEvents(handlers) {
    var map = useMap();
    useEffect(function addMapEventHandlers() {
        map.on(handlers);
        return function removeMapEventHandlers() {
            map.off(handlers);
        };
    }, [
        map,
        handlers
    ]);
    return map;
}


/***/ }),

/***/ 74870:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 84198:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);